import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { ThemeProvider } from '@mui/material/styles'
import API from '../../component/Axios'
import Snackbars from '../../component/Snackbars'
import adminTheme from '../../theme/adminTheme'
import { setAdminSession } from '../../utils/sessionUtils'

export default function Login({ setAuth, setOpen }) {
    const history = useHistory()
    const isMountedRef = useRef(false)
    const [data, setData] = useState({
        email: '',
        password: '',
    })
    const [submitting, setSubmitting] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [severitySnackbar, setSeveritySnackbar] = useState('info')
    const [messageSnackbar, setMessageSnackbar] = useState('')

    useEffect(() => {
        isMountedRef.current = true

        return () => {
            isMountedRef.current = false
        }
    }, [])

    const handleClose = () => {
        setOpenSnackbar(false)
    }

    const handleUpdateField = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const login = async (user) => {
        // 첫 로그인 요청이 끝나기 전에는 중복 제출을 막습니다.
        setSubmitting(true)

        try {
            const { data } = await API.post('/api/v1/admin/auth/login', user)

            if (data.code === 1) {
                setAdminSession({
                    accessToken: data.data.accessToken,
                    adminId: data.data.adminId,
                    role: data.data.role,
                    accessMode: data.data.accessMode,
                })
                
                if (!isMountedRef.current) {
                    return
                }

                setAuth(true)
                setOpen(true)
                history.push({ pathname: data.data.accessMode === 'countryAnalyticsOnly' ? '/appGeoAnalytics' : '/', openSnackbar: true, severitySnackbar: 'success', messageSnackbar: data.message})
                return
            }

            if (!isMountedRef.current) {
                return
            }

            setOpenSnackbar(true)
            setSeveritySnackbar('error')
            setMessageSnackbar(data.message)
        } catch (error) {
            // 일반 code/message 응답이 아닌 네트워크, 서버 오류도 사용자에게 바로 보여줍니다.
            if (!isMountedRef.current) {
                return
            }

            setOpenSnackbar(true)
            setSeveritySnackbar('error')
            setMessageSnackbar(error.response?.data?.message || '로그인 중 오류가 발생했습니다.')
        } finally {
            if (isMountedRef.current) {
                setSubmitting(false)
            }
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        login(data)
    }

    return (
        <ThemeProvider theme={adminTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Log in
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={handleUpdateField}
                            value={data.email}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={handleUpdateField}
                            value={data.password}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            disabled={submitting}
                        >
                            {submitting ? '로그인 중...' : '로그인'}
                        </Button>
                    </Box>
                </Box>
                {openSnackbar && <Snackbars open={openSnackbar} severity={severitySnackbar} message={messageSnackbar} handleClose={handleClose}/>}
            </Container>
      </ThemeProvider>
    )
}
